import { DataSource, Label, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutWaterfallOffers extends Layout {
    labelWaterfallOfferCount: Label;
    sourceMovement: DataSource;
    sourceWaterfallTender: DataSource;
    tableOffers: Table;
}
